import { render, staticRenderFns } from "./LessonGames.vue?vue&type=template&id=150b65c2&scoped=true"
import script from "./LessonGames.vue?vue&type=script&lang=js"
export * from "./LessonGames.vue?vue&type=script&lang=js"
import style0 from "./LessonGames.vue?vue&type=style&index=0&id=150b65c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b65c2",
  null
  
)

export default component.exports